import React, { useState } from 'react';
import { projects } from '../data/mock';
import { Wrench, TrendingUp, CheckCircle2, ArrowRight } from 'lucide-react';
import { projectImages } from '../data/images';

const ProjectsPageIndustrial = () => {
  const [activeProject, setActiveProject] = useState(0);

  return (
    <div className="projects-page-industrial">
      {/* Hero Section */}
      <section style={{
        padding: '140px 0 80px',
        background: 'var(--bg-page)',
        textAlign: 'center'
      }}>
        <div className="container-main">
          <span className="section-label">Case Studies</span>
          <h1 className="hero-industrial-title" style={{ marginBottom: '1rem' }}>
            Real-World Solutions<br />Delivering Results
          </h1>
          <p className="hero-industrial-subtitle" style={{ margin: '0 auto' }}>
            Explore our portfolio of successful projects across various industries
          </p>
        </div>
      </section>

      {/* Projects Grid */}
      <section className="section-padding" style={{ background: 'var(--bg-section-alt)' }}>
        <div className="container-main">
          <div className="projects-grid-new">
            {projects.map((project, idx) => (
              <div
                key={project.id}
                className={`glass-card project-card-new ${activeProject === idx ? 'active' : ''}`}
                style={{ animationDelay: `${idx * 0.1}s`, cursor: 'pointer' }}
                onClick={() => setActiveProject(idx)}
              >
                <div className="project-image-wrapper-new">
                  <img
                    src={projectImages[idx]}
                    alt={project.title}
                    className="project-image-new"
                  />
                  <div className="project-overlay-new"></div>
                  <div style={{
                    position: 'absolute',
                    top: '1rem',
                    right: '1rem',
                    background: 'var(--primary)',
                    color: 'var(--text-inverse)',
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    zIndex: 2
                  }}>
                    {project.industry}
                  </div>
                </div>
                <div className="project-card-body-new">
                  <h3 style={{ 
                    fontSize: '1.5rem',
                    fontWeight: 700,
                    color: 'var(--text-primary)',
                    marginBottom: '0.75rem'
                  }}>
                    {project.title}
                  </h3>
                  <p className="body-small text-text-secondary mb-4 line-clamp-2">
                    {project.challenge}
                  </p>
                  <button className="view-details-btn">
                    View Details <ArrowRight size={18} className="ml-2" />
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* Active Project Details */}
          <div style={{
            background: 'var(--bg-card)',
            padding: '3rem',
            marginTop: '3rem',
            border: '1px solid var(--border-color)'
          }}>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
              {/* Image Section */}
              <div style={{
                position: 'relative',
                borderRadius: '8px',
                overflow: 'hidden',
                minHeight: '400px'
              }}>
                <img
                  src={projectImages[activeProject]}
                  alt={projects[activeProject].title}
                  style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
              </div>

              {/* Content Section */}
              <div>
                <div style={{ marginBottom: '2rem' }}>
                  <span style={{
                    display: 'inline-block',
                    background: 'rgba(253, 183, 20, 0.15)',
                    color: 'var(--primary)',
                    padding: '0.5rem 1rem',
                    borderRadius: '4px',
                    fontSize: '0.75rem',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    marginBottom: '1rem'
                  }}>
                    {projects[activeProject].industry}
                  </span>
                  <h2 style={{
                    fontSize: 'clamp(2rem, 4vw, 2.5rem)',
                    fontWeight: 900,
                    color: 'var(--text-primary)',
                    marginTop: '1rem'
                  }}>
                    {projects[activeProject].title}
                  </h2>
                </div>

                <div className="project-detail-item" style={{ marginBottom: '2rem' }}>
                  <div className="project-detail-icon">
                    <Wrench size={24} />
                  </div>
                  <div>
                    <h4 style={{ 
                      fontSize: '1rem',
                      fontWeight: 700,
                      color: 'var(--primary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase'
                    }}>
                      Challenge
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                      {projects[activeProject].challenge}
                    </p>
                  </div>
                </div>

                <div className="project-detail-item" style={{ marginBottom: '2rem' }}>
                  <div className="project-detail-icon">
                    <TrendingUp size={24} />
                  </div>
                  <div>
                    <h4 style={{ 
                      fontSize: '1rem',
                      fontWeight: 700,
                      color: 'var(--primary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase'
                    }}>
                      Solution
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                      {projects[activeProject].solution}
                    </p>
                  </div>
                </div>

                <div className="project-detail-item">
                  <div className="project-detail-icon">
                    <CheckCircle2 size={24} />
                  </div>
                  <div>
                    <h4 style={{ 
                      fontSize: '1rem',
                      fontWeight: 700,
                      color: 'var(--primary)',
                      marginBottom: '0.5rem',
                      textTransform: 'uppercase'
                    }}>
                      Outcome
                    </h4>
                    <p style={{ color: 'var(--text-secondary)', lineHeight: 1.7 }}>
                      {projects[activeProject].outcome}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectsPageIndustrial;